import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3add5d02&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3add5d02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3add5d02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3add5d02')) {
      api.createRecord('3add5d02', component.options)
    } else {
      api.reload('3add5d02', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3add5d02&scoped=true&", function () {
      api.rerender('3add5d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/getSubBackList/index.vue"
export default component.exports